import { useQuery, useMutation, useQueryClient } from "react-query";
import { getLookupsCategory, getCategory, getCategories, saveCategory, deleteCategory } from "../api/categories-api";

export const key = "categories";

export function useCategoryLookups(enabled = true) {
	return useQuery([key, "lookups"], () => getLookupsCategory(), {
		enabled,
	});
}

export function useCategories(filters, enabled = true) {
	const normalizedFilters = {
		...filters,
		estate_id: filters.estate_id || "",
		estate_parent_id: filters.estate_parent_id || "",
	};

	return useQuery([key, "list", normalizedFilters], () => getCategories(normalizedFilters), { enabled });
}

export function useCategory(filters, slug, canLoadDetail) {
	return useQuery([key, "detail", slug], () => getCategory({ ...filters, slug: slug }), {
		enabled: canLoadDetail,
	});
}

export function useSaveCategory() {
	const queryClient = useQueryClient();

	return useMutation(saveCategory, {
		onMutate: async (variables) => {
			const normalizedFilters = {
				...variables.filters,
				estate_id: variables.filters.estate_id || "",
				estate_parent_id: variables.filters.estate_parent_id || "",
			};

			await queryClient.cancelQueries([key, "list", normalizedFilters]);

			const previousData = queryClient.getQueryData([key, "list", normalizedFilters]);

			queryClient.setQueryData([key, "list", normalizedFilters], (old) => {
				if (!old) return old;

				const updatedData = old.data.map((item) => {
					if (item.id === variables.form.id) {
						return {
							...item,
							name: variables.form.name || item.name,
							description: variables.form.description || item.description,
						};
					}
					return item;
				});

				return {
					...old,
					data: updatedData,
				};
			});

			return { previousData, normalizedFilters };
		},
		onSuccess: (response, _variables, _context) => {
			const normalizedFilters = {
				...response.filters,
				estate_id: response.filters.estate_id || "",
				estate_parent_id: response.filters.estate_parent_id || "",
			};
			const list = response.data;
			const detail = response.detail;

			if (detail && detail.slug) {
				queryClient.setQueryData([key, "detail", detail.slug], detail);
			}

			queryClient.setQueryData([key, "list", normalizedFilters], list);

			return response;
		},
		onError: (error, variables, context) => {
			if (context?.previousData) {
				queryClient.setQueryData([key, "list", context.normalizedFilters], context.previousData);
			}
		},
	});
}

export function useDeleteCategory() {
	const queryClient = useQueryClient();

	return useMutation(deleteCategory, {
		onSuccess: (response, _variables) => {
			const normalizedFilters = {
				...response.filters,
				estate_id: response.filters.estate_id || "",
				estate_parent_id: response.filters.estate_parent_id || "",
			};
			const list = response.data;

			queryClient.setQueryData([key, "list", normalizedFilters], list);
		},
	});
}
